/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import FormGroup from "../../../common/core/FormGroup";
import Input from "../../../common/core/Input";
import Button from "../../../common/core/Button";
import Form from "../../../common/core/Form";
import Spinner from "../../../common/core/Spinner";
import Logo from "../../../common/assets/images/fenix-logo.svg";

const Login = (props) => {
  const {
    handleSubmitLoginDetails,
    error,
    loginData,
    handleChange,
    submitting,
    toggleShowPassword,
    showPasssword,
  } = props;

  return (
    <div className="login-outer">
      <div className="login-panel">
        <div className="login-brand">
          <img src={Logo} alt="" />
          <h4>User Login</h4>
        </div>

        <Form onSubmit={handleSubmitLoginDetails}>
          <fieldset disabled={submitting}>
            <FormGroup className="username">
              <Input
                value={loginData.username}
                type="text"
                name="name"
                id="userName"
                placeholder="Username"
                onChange={(e) => handleChange("username", e)}
                required
              />
            </FormGroup>
            <FormGroup className="password">
              <Input
                value={loginData.password}
                onChange={(e) => handleChange("password", e)}
                type={showPasssword ? "text" : "password"}
                name="password"
                id="userPassword"
                placeholder="Password"
                required
              />
              <Button
                color={`transparent ${showPasssword ? "active" : ""}`}
                onClick={toggleShowPassword}
              />
            </FormGroup>
            <p className="text-danger mb-3 fs-xs">{error}</p>
            {/* <FormGroup className="d-flex justify-content-end mb-2">
              <Button color="link" className="pe-0 text-decoration-none text-primary">
                Forgot Password?
              </Button>
            </FormGroup> */}
            <FormGroup>
              <Button className="w-100" color="primary" block>
                {submitting ? <Spinner size="sm" /> : "Login"}
              </Button>
            </FormGroup>
          </fieldset>
        </Form>
      </div>
    </div>
  );
};

Login.propTypes = {
  handleSubmitLoginDetails: PropTypes.func.isRequired,
  error: PropTypes.objectOf(PropTypes.any).isRequired,
  loginData: PropTypes.objectOf(PropTypes.any).isRequired,
  handleChange: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  showPasssword: PropTypes.bool.isRequired,
  toggleShowPassword: PropTypes.func.isRequired,
};

export default Login;
